import { createRef, Children, cloneElement, Component } from "react"
import PropTypes from "prop-types"

import Sortable from "sortablejs/modular/sortable.core.esm.js"

class SortableWrapper extends Component {
  constructor(props) {
    super(props)
    this.listRef = createRef()
    this.state = {
      items: this.props.items,
      prevPropsSignature: this.props.signature,
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.signature !== state.prevPropsSignature) {
      return {
        prevPropsSignature: props.signature,
        items: props.items,
      }
    }
    return null
  }

  componentDidMount() {
    this.sortable = Sortable.create(this.listRef.current, {
      animation: 150,
      onUpdate: this.handleUpdate,
    })
  }

  componentWillUnmount() {
    if (this.sortable) {
      this.sortable.destroy()
      this.sortable = null
    }
  }

  handleUpdate = e => {
    const old_items = [...this.state.items]
    const [item_to_move] = old_items.splice(e.oldIndex, 1)
    const new_items = [
      ...old_items.slice(0, e.newIndex),
      item_to_move,
      ...old_items.slice(e.newIndex),
    ]
    this.setState({ items: new_items })
    this.props.onOrderUpdate(new_items)
  }

  render() {
    return Children.map(this.props.children, child => {
      return cloneElement(child, { ref: this.listRef })
    })
  }
}

SortableWrapper.propTypes = {
  onOrderUpdate: PropTypes.func.isRequired,
  signature: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  items: PropTypes.array.isRequired,
}

export default SortableWrapper
